import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="path" id="path"></a>
    <h1 {...{
      "id": "windowpath"
    }}>{`window.path`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`path`}</inlineCode>{` module provides utilities for working with file and directory paths.
This module accepts string and Entry object as path parameters.
However, local file schemes, such as `}<inlineCode parentName="p">{`plugin-data:`}</inlineCode>{` or `}<inlineCode parentName="p">{`plugin-temp:`}</inlineCode>{`, will not be resolved to a native path in string paths.
The `}<inlineCode parentName="p">{`path`}</inlineCode>{` module is registered in the global scope and can be used without declaration.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://nodejs.org/api/path.html"
      }}>{`https://nodejs.org/api/path.html`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: UXP v6.4.0  `}</p>
    <a name="path-sep" id="path-sep"></a>
    <h2 {...{
      "id": "sep--string"
    }}>{`sep : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`The platform-specific file separator. '`}{`\\`}{`' or '/'.`}</p>
    <a name="path-delimiter" id="path-delimiter"></a>
    <h2 {...{
      "id": "delimiter--string"
    }}>{`delimiter : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`The platform-specific file delimiter. ';' or ':'.`}</p>
    <a name="path-posix" id="path-posix"></a>
    <h2 {...{
      "id": "posix--object"
    }}>{`posix : `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p>{`It provides access to POSIX specific implementations of the path methods.
Same as parent object on posix.`}</p>
    <a name="path-win32" id="path-win32"></a>
    <h2 {...{
      "id": "win32--object"
    }}>{`win32 : `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p>{`It provides access to Windows-specific implementations of the path methods.
Same as parent object on Windows`}</p>
    <a name="path-normalize" id="path-normalize"></a>
    <h2 {...{
      "id": "normalizepath"
    }}>{`normalize(path)`}</h2>
    <p>{`Normalize a string path, reducing '..' and '.' parts.
When multiple slashes are found, they're replaced by a single one; when the path contains a trailing slash, it is preserved. On Windows backslashes are used.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - normalized string path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`path to normalize`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-join" id="path-join"></a>
    <h2 {...{
      "id": "joinpaths"
    }}>{`join(paths)`}</h2>
    <p>{`Join all arguments together and normalize the resulting path.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - joined string path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if any of the path segments is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`paths`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<(string\\|Entry)>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`paths to join`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-resolve" id="path-resolve"></a>
    <h2 {...{
      "id": "resolvepaths"
    }}>{`resolve(paths)`}</h2>
    <p>{`The right-most parameter is considered {to}. Other parameters are considered an array of {from}.`}</p>
    <p>{`Starting from leftmost {from} parameter, resolves {to} to an absolute path.`}</p>
    <p>{`If {to} isn't already absolute, {from} arguments are prepended in right to left order,
until an absolute path is found. If after using all {from} paths still no absolute path is found,
the current working directory is used as well. The resulting path is normalized,
and trailing slashes are removed unless the path gets resolved to the root directory.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - resolved string path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if any of the arguments is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`paths`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array<(string\\|Entry)>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`a sequence of paths or path segments`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-isabsolute" id="path-isabsolute"></a>
    <h2 {...{
      "id": "isabsolutepath"
    }}>{`isAbsolute(path)`}</h2>
    <p>{`Determines whether {path} is an absolute path. An absolute path will always resolve to the same location, regardless of the working directory.`}</p>
    <p>{`If the given {path} is a zero-length string, `}<inlineCode parentName="p">{`false`}</inlineCode>{` will be returned.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - if the path is an absolute path or not`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`path to test`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-relative" id="path-relative"></a>
    <h2 {...{
      "id": "relativefrom-to"
    }}>{`relative(from, to)`}</h2>
    <p>{`Solve the relative path from {from} to {to} based on the current working directory.
At times we have two absolute paths, and we need to derive the relative path from one to the other. This is actually the reverse transform of path.resolve.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - relative string path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if either `}<inlineCode parentName="li">{`from`}</inlineCode>{` or `}<inlineCode parentName="li">{`to`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`from`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`base path to find from`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`relative path to find to`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-dirname" id="path-dirname"></a>
    <h2 {...{
      "id": "dirnamepath"
    }}>{`dirname(path)`}</h2>
    <p>{`Return the directory name of a path. Similar to the Unix dirname command.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the directory name of a path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the path to evaluate`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-basename" id="path-basename"></a>
    <h2 {...{
      "id": "basenamepath-ext"
    }}>{`basename(path, `}{`[ext]`}{`)`}</h2>
    <p>{`Return the last portion of a path. Similar to the Unix basename command.
Often used to extract the file name from a fully qualified path.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the last portion of a path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string or if `}<inlineCode parentName="li">{`ext`}</inlineCode>{` is given and is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the path to evaluate`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[ext]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`an extension to remove from the result`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-extname" id="path-extname"></a>
    <h2 {...{
      "id": "extnamepath"
    }}>{`extname(path)`}</h2>
    <p>{`Return the extension of the path, from the last '.' to end of string in the last portion of the path.
If there is no '.' in the last portion of the path or the first character of it is '.', then it returns an empty string.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the extension of the path`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the path to evaluate`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-parse" id="path-parse"></a>
    <h2 {...{
      "id": "parsepath"
    }}>{`parse(path)`}</h2>
    <p>{`Returns an object from a path string - the opposite of format().`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - { dir: `}<inlineCode parentName="p">{`string`}</inlineCode>{`, root: `}<inlineCode parentName="p">{`string`}</inlineCode>{`, base: `}<inlineCode parentName="p">{`string`}</inlineCode>{`, name: `}<inlineCode parentName="p">{`string`}</inlineCode>{`, ext: `}<inlineCode parentName="p">{`string`}</inlineCode>{` }`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` if `}<inlineCode parentName="li">{`path`}</inlineCode>{` is not a string`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`path to evaluate`}</td>
        </tr>
      </tbody>
    </table>
    <a name="path-format" id="path-format"></a>
    <h2 {...{
      "id": "formatpathobject"
    }}>{`format(pathObject)`}</h2>
    <p>{`Returns a path string from an object - the opposite of parse().`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - a path string from an object  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pathObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`{ dir: `}<inlineCode parentName="td">{`string`}</inlineCode>{`, root: `}<inlineCode parentName="td">{`string`}</inlineCode>{`, base: `}<inlineCode parentName="td">{`string`}</inlineCode>{`, name: `}<inlineCode parentName="td">{`string`}</inlineCode>{`, ext: `}<inlineCode parentName="td">{`string`}</inlineCode>{` } path to evaluate`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      